<template>
  <div style="height:100%">
    <div class="card-contant" :class="sourceItem.kpiType !== -1 ? 'marginTop' : ''">
      <!-- 工具栏 -->
      <toolbar v-if="sourceItem.labelList && sourceItem.labelList.length > 0" ref="bar" :source-data="sourceItem.labelList" :source-item="sourceItem" @onSonFilter="handleFilter($event,sourceItem)" />

      <!-- 统计数据 20-->
      <template v-if="sourceItem.kpiType == 20">
        <panel-group v-if="sourceItem.listData" :key="sourceItem.code" :count-data="sourceItem.listData.data" />
        <div v-else :key="sourceItem.code" v-loading="true" style="height:100px" />
      </template>
      <!-- 单表格 10 多表头表格 11-->
      <table-page v-if="sourceItem.kpiType == 10 || sourceItem.kpiType == 11" :key="sourceItem.code" :source="source" :source-data="sourceItem.listData" :source-item="sourceItem" :filter-data="filterData" :filter-sondata="filterSondata" :is-page="sourceItem.extra.isPage" @handleResh="handleResh" @tableFilter="handlePage($event,sourceItem)" />

      <!-- 单ECharts >=30-->
      <div v-if="sourceItem.kpiType >= 30" class="chart-box" :style="{'height':sourceItem.height + 55}">
        <!-- 下载 -->
        <el-button v-if="sourceItem.extra.download" class="d-butn" size="mini" icon="el-icon-download" style="font-size: 14px;padding:3px 8px;" title="下载" :loading="sourceItem.extra.downloadLoading" @click="handleDownload(sourceItem)" />

        <chart-page v-if="sourceItem.listData.data && JSON.stringify(sourceItem.listData.data) != '{}'" :id="sourceItem.code" :key="sourceItem.code" :height="parseInt(sourceItem.height)+50 + 'px'" :name="sourceItem.name" :chart-data="sourceItem.listData.data" />
        <div v-else v-loading="true" style="height:350px" />
        <div v-if="sourceItem.listData.title && sourceItem.kpiType == 80" class="bottom-title" v-html="sourceItem.listData.title" />
      </div>

      <!-- 模块展示 21  -->
      <template v-if="sourceItem.kpiType == 21">
        <template v-for="item in sourceItem.listData.data">
          <div v-for="(optionItem,optionIndex) in item.valueList" :key="optionIndex" class="contant-item">
            <div class="item-title">{{ optionItem.name }}</div>
            <div class="item-num" v-html="$options.filters.ullistdata(optionItem.data)" />
          </div>
        </template>
        <div v-if="JSON.stringify(sourceItem.listData) == '{}'" v-loading="true" style="height:165px" />
      </template>

      <!-- tabs ECharts -2-->
      <el-tabs v-if="sourceItem.kpiType == -2 && sourceItem.childs && sourceItem.childs.length > 0" v-model="sourceItem.activeTab" type="card" @tab-click="handleTabClick(sourceItem)">
        <el-tab-pane v-for="(item,index) in sourceItem.childs" :key="index" :label="item.name" :name="item.code">
          <div class="chart-box">
            <!-- 下载 -->
            <el-button v-if="item.extra.download" class="d-butn" size="mini" icon="el-icon-download" style="font-size: 14px;padding:3px 8px;" title="下载" :loading="item.extra.downloadLoading" @click="handleDownload(item)" />

            <chart-page v-if="sourceItem.activeTab == item.code && item.kpiType >= 30 && JSON.stringify(item.listData) != '{}'" :id="item.code" :key="item.code" :name="item.name" :chart-data="item.listData.data" />
            <div v-else v-loading="true" style="height:350px" />
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <template v-if="sourceItem.kpiType == -1 && sourceItem.childs && sourceItem.childs.length > 0">
      <el-row :gutter="20">
        <el-col v-for="(item,index) in sourceItem.childs" :key="index" :span="item.width">
          <module-card-item :source-item="item" @tabClick="handleTabClick(item)" @filterItem="handleFilter($event,item)" @handleResh="handleResh" />
        </el-col>
      </el-row>
    </template>
  </div>
</template>

<script>
import PanelGroup from '../PanelGroup.vue'
import TablePage from '../table/tablePage'
import ChartPage from '../chartPage'
import Toolbar from '../toolbar'
import { houtaixiazai } from '@Bdc~/api/ajax_model'
export default {
  name: 'ModuleCardItem',
  components: { PanelGroup, TablePage, ChartPage, Toolbar },

  filters: {
    ullistdata(value) {
      var vstr = value.substring(0, 1)
      if (vstr == '+') {
        var htmls =
                '<div style="display: inline-block;width: 0;height: 0;border-left: 6px solid transparent;border-right: 6px solid transparent;border-bottom: 10px solid #00b050;margin-top:7px;margin-left:5px;"></div><span style="color:#00b050;margin-left:5px;">' +
                value +
                '</span>'
        return htmls
      } else if (vstr == '-') {
        var htmls =
                '<div style="display: inline-block;width: 0;height: 0;border-left: 6px solid transparent;border-right: 6px solid transparent;border-top: 10px solid #ed5565;margin-top:7px;margin-left:5px;"></div><span style="color:#ed5565;margin-left:5px;">' +
                value +
                '</span>'
        return htmls
      } else {
        return value
      }
    }
  },

  props: {
    // 来源
    source: {
      type: String,
      default: ''
    },

    // 数据源
    sourceItem: {
      type: Object,
      default: () => {}
    },

    // 公共查询条件数据
    filterData: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      filterSondata: {} // 子查询条件
    }
  },

  watch: {
    sourceItem(val) {
      if (val.labelList && val.labelList.length > 0) {
        this.$nextTick(() => {
          this.$refs['bar'].init('son') // 初始化
        })
      }
    }
  },

  mounted() {
    // console.log('11111', this.sourceItem)
    if (this.sourceItem.labelList && this.sourceItem.labelList.length > 0) {
      this.$nextTick(() => {
        this.$refs['bar'].init('son') // 初始化
      })
    }
  },

  methods: {
    // 子查询
    handleFilter(filterSondata, list) {
      this.$nextTick(() => {
        console.log('===子查询', filterSondata, list.code)
        this.filterSondata = JSON.parse(JSON.stringify(filterSondata)) // 子查询条件
      })

      if (list.activeTab) {
        let item = {}
        list.childs.forEach(e => {
          if (list.activeTab == e.code) {
            e.listData = {}
            item = e
          }
        })
        this.$nextTick(() => {
          this.$emit('filterItem', item, filterSondata)
        })
      } else {
        this.$nextTick(() => {
          this.$emit('filterItem', list, filterSondata)
        })
      }
    },

    handlePage(page, list) {
      this.$nextTick(() => {
        this.$emit('pageClick', list, Object.assign({}, page, this.filterSondata))
      })
    },

    // 切换tab 刷新数据
    handleTabClick(list) {
      let item = {}
      list.childs.forEach(e => {
        if (list.activeTab == e.code) {
          e.listData = {}
          item = e
        }
      })
      // console.log('tab切换：',item,this.filterSondata)

      this.$nextTick(() => {
        this.$emit('tabClick', item, this.filterSondata)
      })
    },

    // 下载
    async handleDownload(item) {
      item.extra.downloadLoading = true
      const headerObj = {
        'header_view_code': item.code,
        'header_time_type': item.timeType
      }

      for (var key in this.filterData) { // 公共查询
        if (this.filterData.hasOwnProperty(key) === true) {
          headerObj[key] = this.filterData[key]
        }
      }
      // console.log('下载====',headerObj, this.filterSondata)
      await houtaixiazai(headerObj, this.filterSondata)

      item.extra.downloadLoading = false
    },

    // 刷新
    handleResh(item) {
      this.$emit('handleResh', item, this.filterSondata)
    }
  }
}
</script>

<style lang="scss" scoped>
    .marginTop{
        margin-top: 15px;
    }
    .card-contant{
        text-align: center;
        ::v-deep .el-tabs__item{
            height: 34px;
            line-height: 34px;
            padding: 0 12px !important;
        }
    }
    .bottom-title{
        margin-bottom: 15px;
        font-size: 14px;
    }
    .contant-item{
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-between;
        align-items: flex-start;
        margin: 20px 0;
        line-height: 22px;
        .item-title{
            color: #666;
            font-size: 14px;
        }
        .item-num{
            color: #666;
            font-size: 18px;
        }
    }

    ::v-deep .el-loading-mask{
        z-index: 1 !important;
    }

    .chart-box{
        position: relative;
        padding-top: 5px;
        .d-butn{
            position: absolute;
            top:0;
            right:0;
            z-index:1
        }
    }
</style>
